export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "life_predictions": "మీ జీవిత భవిష్యవాణులు",
    "future_unveiled_through_stars": "నక్షత్రాల ద్వారా వెల్లడైన భవిష్యత్తు",
    "life_predictions_description": "వేద జ్యోతిష్యం మరియు గ్రహ విశ్లేషణ ఆధారంగా సమగ్ర జీవిత భవిష్యవాణులను పొందండి. మీ భవిష్యత్ మైలురాళ్లు, ప్రధాన సంఘటనలు, కెరీర్ వృద్ధి, వివాహ సమయం, సంపద సేకరణతో పాటు ఖచ్చితమైన జ్యోతిష్య అంతర్దృష్టులను తెలుసుకుని, మీ ఆధ్యాత్మిక యాత్రను అర్థం చేసుకోండి.",

    // Service Information
    "enter_details_for_predictions": "జీవిత భవిష్యవాణుల కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_life_predictions": "పూర్ణ జీవిత భవిష్యవాణులు",
    "service_price": "సేవా ధర",
    "comprehensive_life_predictions_note": "మీ భవిష్యత్ జీవిత సంఘటనలు మరియు జ్యోతిష్య మార్గదర్శనం యొక్క వివరణాత్మక విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_destiny_influence": "మీ పేరు కంపనలు మీ విధి మరియు భవిష్యత్ అవకాశాలను ఆకారపరుస్తాయి",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_future_insights": "గ్రహ కాలాలు మరియు భవిష్యత్ భవిష్యవాణుల గణనకు అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_predictions": "ఖచ్చితమైన దశా గణనలు మరియు భవిష్యవాణుల కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_essential_for_predictions": "స్థానం భవిష్యత్ సంఘటనలను ప్రభావితం చేసే గ్రహ స్థానాలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ జీవిత భవిష్యవాణులు ఎంచుకున్న భాషలో అందించబడతాయి",

    // Core Prediction Features
    "future_life_events_predictions": "భవిష్యత్ జీవిత సంఘటనల భవిష్యవాణులు",
    "career_success_timeline": "కెరీర్ విజయ కాలక్రమం",
    "marriage_relationship_predictions": "వివాహ మరియు సంబంధ భవిష్యవాణులు",
    "wealth_prosperity_forecast": "సంపద మరియు సమృద్ధి అంచనా",
    "health_longevity_insights": "ఆరోగ్యం మరియు దీర్ఘాయువు అంతర్దృష్టులు",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ జీవిత భవిష్యవాణులలో ఉన్నవి",
    "comprehensive_future_roadmap": "సమగ్ర భవిష్యత్ రోడ్‌మ్యాప్",
    "major_life_events_timeline": "ప్రధాన జీవిత సంఘటనల కాలక్రమం",
    "planetary_influence_analysis": "గ్రహ ప్రభావ విశ్లేషణ",
    "remedial_guidance_solutions": "పరిహార మార్గదర్శనం మరియు పరిష్కారాలు",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా జీవిత భవిష్యవాణులు పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "భవిష్యవాణులను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "life_predictions_processing": "మీ జీవిత భవిష్యవాణులు మా నిపుణ వేద జ్యోతిష్యులచే తయారు చేయబడుతున్నాయి. మీ భవిష్యత్ జీవిత సంఘటనలు మరియు కాస్మిక్ కాలక్రమంపై వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_24_hours_delivery_note": "మీ వివరణాత్మక జీవిత భవిష్యవాణులు 24 గంటలలోపు తయారవుతాయి",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి భవిష్యవాణులు అందించబడతాయి",

    // What You'll Receive
    "what_youll_receive": "మీ జీవిత భవిష్యవాణుల ప్యాకేజ్",
    "detailed_life_predictions": "సమగ్ర జీవిత భవిష్యవాణుల నివేదిక (PDF)",
    "future_events_timeline": "భవిష్యత్ సంఘటనల కాలక్రమం మరియు తేదీలు",
    "career_marriage_wealth_predictions": "కెరీర్, వివాహం మరియు సంపద భవిష్యవాణులు",
    "planetary_periods_analysis": "గ్రహ కాలాల (దశా) విశ్లేషణ",
    "remedial_solutions_guidance": "పరిహార పరిష్కారాలు మరియు మార్గదర్శనం",

    // Visual Content
    "sample_life_predictions": "నమూనా జీవిత భవిష్యవాణులు",
    "major_life_milestone": "ప్రధాన జీవిత మైలురాయి",
    "sample_prediction_reading": "రాబోయే 2-3 సంవత్సరాలలో కెరీర్ పురోగతి మరియు వివాహ అవకాశాలు",
    "sample_predictions_preview": "కాలక్రమ అంతర్దృష్టులతో మీ వ్యక్తిగత జీవిత భవిష్యవాణుల మునుజూపు",
    "life_prediction_areas": "జీవిత భవిష్యవాణుల రంగాలు",

    // Life Area Types
    "career": "కెరీర్",
    "marriage": "వివాహం",
    "wealth": "సంపద",
    "family": "కుటుంబం",
    "health": "ఆరోగ్యం",
    "education": "విద్య",

    // Status & Processing
    "your_predictions_status": "మీ జీవిత భవిష్యవాణుల స్థితి",
    "processing_your_predictions": "మీ భవిష్యత్తును విశ్లేషిస్తోంది",
    "predictions_processing_message": "మా వేద జ్యోతిష్య నిపుణులు మీ గ్రహ కాలాలను గణిస్తూ మీ జన్మ కుండలి ఆధారంగా భవిష్యత్ సంఘటనలను విశ్లేషిస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_24_hours": "24 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "జ్యోతిష్య మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "భవిష్యవాణుల ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Prediction-Specific Elements
    "planetary_periods": "గ్రహ కాలాలు (దశలు)",
    "mahadasha": "మహాదశా కాలాలు",
    "antardasha": "అంతర్దశా ఉప-కాలాలు",
    "pratyantar_dasha": "ప్రత్యంతర్ దశా",
    "transit_analysis": "గ్రహ గమనాలు",
    "yogas_combinations": "మంగళకరమైన యోగాలు మరియు కలయికలు",

    // Life Events Predictions
    "career_milestones": "కెరీర్ మైలురాళ్లు",
    "job_changes": "ఉద్యోగ మార్పులు మరియు పదోన్నతులు",
    "business_opportunities": "వ్యాపార అవకాశాలు",
    "educational_achievements": "విద్యా సాధనలు",
    "marriage_timing": "వివాహ సమయం",
    "childbirth_predictions": "సంతానోత్పత్తి భవిష్యవాణులు",
    "property_acquisition": "ఆస్తి మరియు రియల్ ఎస్టేట్",
    "travel_opportunities": "ప్రయాణం మరియు విదేశీ అవకాశాలు",

    // Career Predictions
    "professional_growth": "వృత్తిపరమైన వృద్ధి కాలక్రమం",
    "success_periods": "విజయం మరియు గుర్తింపు కాలాలు",
    "career_challenges": "కెరీర్ సవాలు కాలాలు",
    "leadership_roles": "నాయకత్వ అవకాశాలు",
    "business_ventures": "వ్యాపార వెంచర్ విజయం",
    "financial_growth": "ఆర్థిక వృద్ధి నమూనాలు",

    // Marriage & Relationships
    "love_life_predictions": "ప్రేమ జీవిత భవిష్యవాణులు",
    "marriage_compatibility": "వివాహ భాగస్వామి అనుకూలత",
    "relationship_timing": "సంబంధ మైలురాళ్లు",
    "family_expansion": "కుటుంబ వృద్ధి మరియు పిల్లలు",
    "marital_harmony": "వైవాహిక సామరస్య కాలాలు",
    "relationship_challenges": "సంబంధ సవాలు కాలాలు",

    // Wealth & Finance
    "wealth_accumulation": "సంపద సంచయన కాలక్రమం",
    "investment_success": "పెట్టుబడి విజయ కాలాలు",
    "property_gains": "ఆస్తి మరియు అసెట్ లాభాలు",
    "business_profits": "వ్యాపార లాభ చక్రాలు",
    "financial_setbacks": "ఆర్థిక సవాలు కాలాలు",
    "debt_recovery": "రుణ రికవరీ మరియు ఆర్థిక స్థిరత్వం",

    // Health & Longevity
    "health_timeline": "ఆరోగ్య కాలక్రమ భవిష్యవాణులు",
    "disease_periods": "ఆరోగ్య సవాలు కాలాలు",
    "recovery_periods": "రికవరీ మరియు వైద్య కాలాలు",
    "longevity_analysis": "దీర్ఘాయువు మరియు జీవిత కాలం విశ్లేషణ",
    "accident_prone_periods": "ప్రమాదం జరిగే అవకాశం ఉన్న కాలాలు",
    "vitality_enhancement": "జీవశక్తి మెరుగుదల కాలాలు",

    // Family & Social
    "family_events": "కుటుంబ సంఘటనలు మరియు మైలురాళ్లు",
    "children_predictions": "పిల్లలకు సంబంధించిన భవిష్యవాణులు",
    "parental_health": "తల్లిదండ్రుల ఆరోగ్యం మరియు క్షేమం",
    "sibling_relationships": "తోబుట్టువుల సంబంధాలు",
    "social_recognition": "సామాజిక స్థితి మరియు గుర్తింపు",
    "community_involvement": "కమ్యూనిటీ నాయకత్వ పాత్రలు",

    // Spiritual & Personal Growth
    "spiritual_awakening": "ఆధ్యాత్మిక మేల్కొలుపు కాలాలు",
    "religious_inclinations": "మతపరమైన మరియు ఆధ్యాత్మిక ప్రవృత్తులు",
    "pilgrimage_opportunities": "తీర్థయాత్ర మరియు పవిత్ర యాత్రలు",
    "meditation_periods": "ధ్యానం మరియు అంతర్గత వృద్ధి",
    "guru_connections": "ఆధ్యాత్మిక గురువు సంబంధాలు",
    "moksha_path": "విముక్తి మరియు జ్ఞానోదయ మార్గం",

    // Timing & Cycles
    "auspicious_periods": "మంగళకరమైన కాల వ్యవధులు",
    "challenging_periods": "సవాలు కాల వ్యవధులు",
    "neutral_periods": "తటస్థ మరియు స్థిరమైన కాలాలు",
    "transformation_phases": "ప్రధాన రూపాంతర దశలు",
    "opportunity_windows": "అవకాశ కిటికీలు",
    "decision_making_periods": "అనువైన నిర్ణయ తీసుకునే సమయాలు",

    // Age-Based Predictions
    "childhood_predictions": "బాల్యం మరియు ప్రారంభ జీవితం",
    "teenage_predictions": "కిశోరావస్థ మరియు యువత భవిష్యవాణులు",
    "young_adult_phase": "యువ వయోజన దశ (20-35)",
    "middle_age_predictions": "మధ్య వయస్సు భవిష్యవాణులు (35-55)",
    "senior_years": "వృద్ధాప్య సంవత్సరాలు మరియు పదవీ విరమణ",
    "life_completion": "జీవిత పూర్తికరణ మరియు వారసత్వం",

    // Remedies & Solutions
    "planetary_remedies": "గ్రహ పరిహారాలు",
    "gemstone_recommendations": "రత్న సిఫార్సులు",
    "mantra_chanting": "లాభదాయకమైన మంత్రాలు",
    "charity_suggestions": "దాతృత్వ కార్యకలాపాలు",
    "ritual_recommendations": "కర్మ మరియు పూజా సిఫార్సులు",
    "lifestyle_modifications": "జీవనశైలి మార్పులు",

    // Advanced Predictions
    "karma_analysis": "కర్మ నమూనా విశ్లేషణ",
    "past_life_influences": "పూర్వ జన్మ ప్రభావాలు",
    "soul_purpose": "ఆత్మ ఉద్దేశ్యం మరియు మిషన్",
    "destiny_fulfillment": "విధి నెరవేర్పు మార్గం",
    "life_lessons": "ప్రధాన జీవిత పాఠాలు",
    "evolutionary_growth": "పరిణామాత్మక ఆత్మ వృద్ధి",

    // Specific Event Timing
    "marriage_age_prediction": "వివాహ వయస్సు భవిష్యవాణి",
    "first_child_timing": "మొదటి సంతానం సమయం",
    "career_peak_period": "కెరీర్ శిఖర కాలం",
    "maximum_wealth_phase": "గరిష్ఠ సంపద దశ",
    "health_recovery_timing": "ఆరోగ్య రికవరీ సమయం",
    "spiritual_realization": "ఆధ్యాత్మిక సాక్షాత్కార దశ",

    // Global & Environmental
    "foreign_opportunities": "విదేశీ ప్రయాణం మరియు అవకాశాలు",
    "relocation_predictions": "స్థలాంతరం మరియు వలస",
    "global_connections": "అంతర్జాతీయ సంబంధాలు",
    "cultural_exchanges": "సాంస్కృతిక మరియు విద్యా మార్పిడిలు",
    "technology_adaptations": "టెక్నాలజీ మరియు ఇన్నోవేషన్ పాల్గొనడం",

    // Detailed Time Frames
    "next_year_predictions": "వచ్చే సంవత్సర భవిష్యవాణులు",
    "next_5_years": "రాబోయే 5 సంవత్సరాల సమీక్ష",
    "next_10_years": "రాబోయే దశాబ్దం అంచనా",
    "life_phases": "ప్రధాన జీవిత దశలు",
    "cyclical_patterns": "పునరావృత జీవిత నమూనాలు",
    "milestone_achievements": "ప్రధాన మైలురాయి సాధనలు"
};
